import React from 'react';

type SectionProps = {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
};

const Section: React.FC<SectionProps> = ({ title, subtitle, children }) => {
  return (
    <section className="flex flex-col gap-y-md border border-active rounded-sm p-xl bg-content">
      {!!title && (
        <h3 className="text-base font-semibold text-text">{title}</h3>
      )}
      {!!subtitle && <p className="text-small text-textLight">{subtitle}</p>}
      {children}
    </section>
  );
};

export default React.memo(Section) as typeof Section;
